import React from 'react';
import Modal from 'react-responsive-modal';
import * as Yup from 'yup';
import { Field, Form, Formik } from 'formik';
import { Button } from '@synergy-marine-group/synergy-ui';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { ppeAddModalStyles } from '../Modal/styles';
import DropdownFieldComponent from '../common/FormComponents/DropdownFieldComponent';
import InputFieldComponent from '../common/FormComponents/InputFieldComponent';
import formatDropdownOptions from '../../utils/formatDropdownOptions';
import createPpeComponent from './queries/createPpeComponent';
import updatePpeComponent from './queries/updatePpeComponent';
import getAdhocItem from './queries/getAdhocItem';

const validationSchema = Yup.object({
  ppeComponentMasterId: Yup.string().required('Please select the Component'),
  quantity: Yup.number().required('Please select the Quantity')
});
const AddPPE = ({ modal, setModal, items, setItems, mode, setMode }) => {
  const ppeMasterId = useParams();
  const { mutate: createPpeComponentNew } = createPpeComponent();
  const { mutate: updatePpeComponents } = updatePpeComponent();

  const { data: ComponentList } = getAdhocItem();
const components = formatDropdownOptions(ComponentList?.data?.items, 'name', 'id');
    const handleSubmit = (data) => {
      // eslint-disable-next-line max-len
      const { unitPrice, unitPriceUsd, name } = ComponentList?.data?.items?.find((item) => item.id === data.ppeComponentMasterId);
      const dataFinal = { ...data,
        ppeMasterId: ppeMasterId.itemId,
        unitPrice,
        unitPriceUsd,
        componentName: name };

      if (mode === 'add') {
        createPpeComponentNew(dataFinal);
      } else {
        updatePpeComponents(dataFinal);
      }
        setMode('add');
        setModal(false);
        setItems({ ppeComponentMasterId: '',
        quantity: 1
    });
    };

  return (
    <Modal
    open={modal}
    onClose={() => setModal(false)}
    closeOnOverlayClick
    showCloseIcon={false}
    styles={ppeAddModalStyles}
    center
    >
      <div className="uppercase text-center font-bold text-xl pb-5 font-montserrat">
        {mode === 'add' ? 'Add Component Mapping' : 'Edit Component Mapping'}
      </div>
      <Formik
        initialValues={items}
        oncancel={() => setModal(false)}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleSubmit(values);
        }}
      >
        {({ values }) => {
            return (
        <Form>
          <div className="w-auto input-default">
            <div className="align-middle align-center">
              <div className="grid grid-cols-1 gap-4 pb-7">
                <Field
                  name="ppeComponentMasterId"
                  component={DropdownFieldComponent}
                  className="w-full"
                  options={components}
                  size="large"
                  rounded
                  id="select1"
                  type="text"
                  requiredField
                  label="Component"
                  isDisabled={mode === 'edit'}
                  maxMenuHeight={100}
                />

                <Field
                  name="quantity"
                  component={InputFieldComponent}
                  className="w-full"
                  min={1}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^\d]/g, '').slice(0, 10);
                  }}
                  size="large"
                  rounded
                  id="select1"
                  type="number"
                  requiredField
                  onWheel={(e) => e.target.blur()}
                  label="Quantity"
                />
              </div>
            </div>
          </div>
          <div className="flex justify-end">
            <Button
              className="max-w-none mr-4 font-montserrat text-gray-500 uppercase text-sm"
              onClick={() => {
                setItems({ ppeComponentMasterId: '',
                quantity: 1
            });
                setModal(false);
              }}
              size="small"
              variant="outlined"
              rounded
              type="reset"
            >
              Cancel
            </Button>

            <Button
            disabled={values?.ppeComponentMasterId === items?.ppeComponentMasterId
              && values?.quantity === items?.quantity}
            className="max-w-none font-montserrat text-gray-500 uppercase text-sm"
            size="small"
            variant=" filled"
            rounded
            type="submit"
            >
              {mode === 'add' ? 'Add' : 'Update'}
            </Button>
          </div>
        </Form>
        );
        }}
      </Formik>
    </Modal>
  );
};

export default AddPPE;
